import * as React from "react"
import { cn } from "../../lib/utils"

export interface DashboardLayoutProps {
  children: React.ReactNode
  sidebar?: React.ReactNode
  header?: React.ReactNode
  className?: string
}

const DashboardLayout = React.forwardRef<HTMLDivElement, DashboardLayoutProps>(
  ({ children, sidebar, header, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex h-screen overflow-hidden bg-background", className)}
        {...props}
      >
        {sidebar && (
          <aside className="hidden border-r border-border bg-sidebar-background lg:block">
            {sidebar}
          </aside>
        )}
        <div className="flex flex-1 flex-col overflow-hidden">
          {header && (
            <div className="border-b border-border bg-background">
              {header}
            </div>
          )}
          <main className="flex-1 overflow-auto bg-background">
            {children}
          </main>
        </div>
      </div>
    )
  }
)
DashboardLayout.displayName = "DashboardLayout"

const DashboardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex-1 space-y-6 p-6 md:p-8", className)}
    {...props}
  >
    {children}
  </div>
))
DashboardContent.displayName = "DashboardContent"

const DashboardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn("border-b border-border bg-background px-6 py-4", className)}
    {...props}
  >
    {children}
  </header>
))
DashboardHeader.displayName = "DashboardHeader"

export { DashboardLayout, DashboardContent, DashboardHeader }
